<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <b-icon icon="tools" class="m-2"></b-icon>
                Ajout de frais de matériel
            </p>
        </header>
        <section class="modal-card-body">

            <b-field label="Fournisseur">
                <b-input type="text" v-model="payload.mat" placeholder="Ajouter">
                </b-input>
            </b-field>

            <b-field label="Coût">
                <b-input type="number" min="0" step="0.01" v-model="payload.cost">
                </b-input>
            </b-field>

            <b-field label="N° devis">
                <b-input type="text" v-model="payload.devis">
                </b-input>
            </b-field>

          <b-field label="Commentaire">
            <b-input type="text" v-model="payload.comment">
            </b-input>
          </b-field>

        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Annuler
            </button>
            <button class="button is-primary" @click="addMAT">Enregistrer</button>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "MATAddModal",
        data() {
            return {
                payload: {},
            };
        },
        methods: {
            addMAT() {
                if (this.payload.mat !== "" &&
                    this.payload.mat !== undefined &&
                    parseFloat(this.payload.cost) >= 0) {
                    this.$emit("add-mat", this.payload);
                } else {
                    this.$buefy.snackbar.open(
                        {
                            message: `Mauvaise saisie, merci de vérifier`,
                            type: 'is-danger',
                            position: 'is-bottom-left'
                        });
                }
            }
        }
    };
</script>

<style scoped></style>
